import React from 'react';

const SpinnerIcon = () => {
  return (
    <div
      className="spinner-icon"
      style={{
        width: '20px', // Adjust the size to fit within the heart icon wrapper
        height: '20px',
        position: 'relative',
      }}
    >
      <div
        className="double-bounce1"
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: '#3498db',
          opacity: 0.6,
          position: 'absolute',
          top: 0,
          left: 0,
          animation: 'bounce 2.0s infinite ease-in-out',
        }}
      ></div>
      <div
        className="double-bounce2"
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundColor: '#3498db',
          opacity: 0.6,
          position: 'absolute',
          top: 0,
          left: 0,
          animation: 'bounce 2.0s infinite ease-in-out',
          animationDelay: '-1.0s',
        }}
      ></div>
    </div>
  );
};

export default SpinnerIcon;
